export default {
  // Endpoints
  loginEndpoint: '/web/auth/login',
  logoutEndpoint: '/web/auth/logout',
  meEndpoint: '/web/me',
  forgotPassword: '/web/auth/forgot-password',
  resetPasswordValidate: '/web/auth/reset-password/validate',
  resetPassword: '/web/auth/reset-password',
}
